import _ from 'lodash';
import React from 'react';

import {
  Box,
  Button,
  IconButton,
  styled
} from '@mui/material';
import {
  BaseModal,
  fields,
  Form
} from 'iron-forge-react-modules';

import { Close } from '@mui/icons-material';
import { appFormUtil } from 'modules/layer00';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import * as types from './types';



const FormContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

const TextFieldController = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  orderId?: string;
  returnAuthorizationId?: string;
  isCustomer?: boolean;

  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    fnSendChatMessage,
    sendChatMessageTuple
  ] = dataService.useSendOrderChatMessage(props.orderId ?? '');
  const [
    fnSendReturnAuthorizationChatMessage,
    sendReturnAuthorizationChatMessageTuple
  ] = dataService.useSendReturnAuthorizationChatMessage(props.returnAuthorizationId ?? '');
  const [
    sendChatMessageAsCustomer,
    sendChatMessageAsCustomerTuple
  ] = dataService.useSendChatMessageAsCustomer({
    orderId: props.orderId,
    returnAuthorizationId: props.returnAuthorizationId
  });

  const form = useForm<types.IFormState>({
    defaultValues: {
      content: ''
    }
  });



  const fnCloseButton: BaseModal.IProps['fnGenElTopCloseButton'] = ({ onClose }) => (
    <IconButton onClick={onClose}>
      <Close />
    </IconButton>
  );



  async function processSubmit(formState: types.IFormState) {
    const data = appFormUtil.trimFormStateValues(formState);
    if (props.isCustomer) {
      await sendChatMessageAsCustomer(data);

    } else {
      if (props.orderId) {
        await fnSendChatMessage(data);
      } else if (props.returnAuthorizationId) {
        await fnSendReturnAuthorizationChatMessage(data);
      }
    }

    props.onClose();
  }

  function handleClickCancel() {
    props.onClose();
  }




  React.useEffect(() => {
    _.defer(() => {
      form.setFocus('content', { shouldSelect: true });
    });
  }, [form]);



  const loading = sendChatMessageTuple.loading
    || sendChatMessageAsCustomerTuple.loading
    || sendReturnAuthorizationChatMessageTuple.loading;



  const content = (
    <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
      <FormContainerBox>
        <TextFieldController
          isDisabled={loading}
          label="Message"
          formControl={form.control}
          fieldKey="content"
          numLines={5}
          isRequired
          showLengthInLabel
          extraValidationRules={{
            maxLength: 1000
          }} />

        <ButtonBox>
          <Button
            disabled={loading}
            onClick={handleClickCancel}>
            Cancel
          </Button>

          <Button
            disabled={loading}
            type="submit">
            Save
          </Button>
        </ButtonBox>
      </FormContainerBox>
    </Form.FC>
  );

  return (
    <BaseModal.FC
      isOpen
      fnGenElTopCloseButton={fnCloseButton}
      fnGenElCloseButton={fnCloseButton}>
      {() => content}
    </BaseModal.FC>
  );
};
